import { render, staticRenderFns } from "./ConfigureReport.vue?vue&type=template&id=322a6b9a&scoped=true&"
import script from "./ConfigureReport.vue?vue&type=script&lang=js&"
export * from "./ConfigureReport.vue?vue&type=script&lang=js&"
import style0 from "./ConfigureReport.vue?vue&type=style&index=0&id=322a6b9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322a6b9a",
  null
  
)

export default component.exports